<template>
    <div class="pop" v-show="show">
        <div class="box">
            <div class="title">{{title}}<span @click="cancel" class="closeBtn"></span></div>
            <div class="wrap">
                <div class="notice" v-html="notice"></div>
                <div class="info">
                    <label :style="{width: labelWidth + 'px'}">{{accountLabel}}</label>
                    <input type="text" :disabled="disable" v-model="innerAccount">
                </div>
                <div class="info" v-if="!noPassword">
                    <label :style="{width: labelWidth + 'px'}">密码</label>
                    <input type="password" v-model="innerPassword">
                </div>
                <div class="tips" v-html="tips"></div>
                <div style='text-align:center;'>
                    <button class="btn" @click='agree' :disabled="disableSubmit" :class="{disable: disableSubmit}">
                        <span style="display:block;position:relative;height:20px;" v-show='loading'>

                            <i class="i1"></i>
                            <i class="i2"></i>
                            <i class="i3"></i>
                            <i class="i4"></i>
                            <i class="i5"></i>
                            <i class="i6"></i>
                            <i class="i7"></i>
                            <i class="i8"></i>
                        </span>
                        <span v-show='!loading'>
                            验证
                        </span>
                    </button>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'accountValid',
        data: () => ({
            show: true,
            innerAccount: "",
            innerPassword: "",
            loading: false,
            tips: ''
        }),
        props: {
            title: {
                default: '账号验证',
                type: String
            },
            account: {
                default: '',
                type: String
            },
            accountLabel: {
                default: '账号',
                type: String
            },
            noPassword: {
                default: false,
                type: Boolean
            },
            disable: {
                default: false,
                type: Boolean
            },
            required: {
                default: false,
                type: Boolean
            },
            notice: {
                default: '',
                type: String
            },
            ok: {
                default: () => {},
                type: Function
            },
            close: {
                default: () => {},
                type: Function
            },
            labelWidth: {
                default: null,
                type: Number
            }
        },
        methods: {
            cancel() {
                this.show = false
                this.close()
            },
            agree() {
                this.loading = true
                this.tips = ''
                this.ok(()=>{
                    this.loading = false
                    this.show = false
                    this.tips = ''
                },tips =>{
                    this.tips = tips
                    this.loading = false
                },this.innerAccount,this.innerPassword)
            }
        },
        watch:{
            account: {
                handler (val) {
                    this.innerAccount = this.account
                },
                immediate:true
            }
        },
        components: {

        },
        computed: {
            disableSubmit () {
                if (this.noPassword) {
                    return !(this.required && this.innerAccount !== '')
                } else {
                    return !(this.required && this.innerAccount !== '' && this.innerPassword !== '')
                }
            }
        },
        mounted() {
            
        }
    }
</script>

<style scoped>
    .pop {
        position: fixed;
        z-index: 2000;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .2);
    }

    .box {
        width: 494px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .title {
        height: 34px;
        background: url(../assets/image/confirm_title_bg.jpg) no-repeat;
        color: #fafafa;
        font-size: 15px;
        line-height: 34px;
        padding-left: 11px;
    }

    .wrap {
        background: #fff;
        border: 1px solid #8b8b8b;
        border-top: 0;
        padding: 30px 55px;
        color: #7c7c7c;
        font-weight: bolder;
        font-size: 14px;
    }

    .btn {
        color: #fff;
        font-weight: bolder;
        background: rgb(73, 132, 212);
        padding: 5px 28px;
        cursor: pointer;
        display: inline-block;
        /* width: 96px; */
        zoom: 1;
        border: 0;
        outline: 0;
        margin: 25px 10px 0;
    }
    .btn.disable {
        
        opacity: 0.75;
    }
    .closeBtn {
        width: 35px;
        height: 35px;
        position: absolute;
        right: 0;
        top: 0;
        background: url(../assets/image/close.png) no-repeat center;
        background-size: 12px;
        cursor: pointer;
    }

    input,
    select {
        height: 32px;
        border: 1px solid #d4d4d4;
        width: 60%;
        background-color: #ffffff;
        padding: 0 10px;
        box-sizing: border-box;
        outline: none;
    }

    label {
        width: auto;
        display: inline-block;
        text-align: right;
        margin-right: 10px;
    }

    input[type="text"]:disabled {
        border: 1px solid transparent;
        background: transparent;
    }

    .info {
        margin-bottom: 10px;
        padding-left: 50px;
    }



    .btn:hover {
        opacity: 0.75;
    }

    .btn.blue {
        background: rgb(6, 96, 172);
    }

    .btn.red {
        background: rgb(212, 2, 1);
    }

    .btn i {
        display: inline-block;
        width: 6px;
        height: 2px;
        background: white;
        border-radius: 1px;
    }

    @keyframes flash {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    .btn .i1 {
        animation: flash .8s ease infinite;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: -1px;
        margin-left: 3px;

    }

    .btn .i2 {
        animation: flash .8s ease infinite .1s;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: -6px;
        margin-left: 1px;
        transform: rotate(-45deg);
    }

    .btn .i3 {
        animation: flash .8s ease infinite .2s;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: -7px;
        margin-left: -4px;
        transform: rotate(90deg);
    }

    .btn .i4 {
        animation: flash .8s ease infinite .3s;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: -6px;
        margin-left: -9px;
        transform: rotate(45deg);
    }

    .btn .i5 {
        animation: flash .8s ease infinite .4s;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: -1px;
        margin-left: -11px;
    }

    .btn .i6 {
        animation: flash .8s ease infinite .5s;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: 5px;
        margin-left: -9px;
        transform: rotate(-45deg);
    }

    .btn .i7 {
        animation: flash .8s ease infinite .6s;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: 7px;
        margin-left: -4px;
        transform: rotate(90deg);
    }

    .btn .i8 {
        animation: flash .8s ease infinite .7s;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: 5px;
        margin-left: 2px;
        transform: rotate(45deg);
    }
    .tips {
        padding-left: 50px;
        min-height: 16px;
        color: crimson;
    }
    .notice{
        background: none;
        min-height: 16px;
        font-size: 14px;
        color: #666;
        padding-left: 0;
        margin-bottom: 15px;
    }
</style>